import React from 'react'

const CounterSkeleton = ({ width = 'w-12' }) => (
  <div className={`h-6 ${width} rounded bg-gray-100 dark:bg-gray-600 animate-pulse`} />
)

export default CounterSkeleton
